import { render, staticRenderFns } from "./PxCamposCompraItemUseall.vue?vue&type=template&id=242f5709&"
import script from "./PxCamposCompraItemUseall.vue?vue&type=script&lang=js&"
export * from "./PxCamposCompraItemUseall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports